<template>
  <el-button
    size="small"
    @click="onClick"
  >{{ $t('components_switchButton.geng_duo_shai_xuan') }}
    <i
      class="el-icon-arrow-up el-icon--right"
      v-if="open"
    ></i>
    <i
      class="el-icon-arrow-down el-icon--right"
      v-else
    ></i>
  </el-button>
</template>

<script>

export default {
  props: {
    // 下拉container
    link: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler(val) {
        this.open = val;
        this.syncContainer();
      },
      immediate: true
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    triggerClose() {
      this.open = false;
      this.syncContainer();
      this.$emit('close');
    },
    onClick() {
      this.open = !this.open;
      this.syncContainer();
      this.emit();
    },
    // 同步container展开或者收起
    syncContainer() {
      const container = this.getContainer();
      if (container) {
        if (this.open) {
          container.open();
        } else {
          container.close();
        }
      }
    },
    getContainer() {
      return this.link;
    },
    // 传递事件
    emit() {
      this.$emit('click');
      if (this.open) {
        this.$emit('open');
      } else {
        this.$emit('close');
      }
    }
  },
  mounted() {
  }
};
</script>

<style></style>
